import { useEffect, useState } from 'react'

const COARSE_POINTER_QUERY = '(pointer: coarse)'

function readCoarsePointer(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(COARSE_POINTER_QUERY).matches
    : false
}

export function useIsCoarsePointer(): boolean {
  const [isCoarse, setIsCoarse] = useState(readCoarsePointer)

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      throw new Error('Pointer-based layout requires window.matchMedia support')
    }
    const media = window.matchMedia(COARSE_POINTER_QUERY)
    const update = () => setIsCoarse(media.matches)
    update()
    media.addEventListener('change', update)
    return () => media.removeEventListener('change', update)
  }, [])

  return isCoarse
}
